/* eslint-disable react/jsx-max-depth */
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
// import queryString from 'querystring';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import { Flex, Modal, Text, Accordion, Grid } from '@mantine/core';
import { AppContext } from '../../contexts';
import { submitUploadSubMerchantActivation } from './actions';
import FormUpload from './FormUpload';
import IconSuccess from '../../components/icons/IconSuccess';
import IconFailed from '../../components/icons/IconFailed';

import styles from './styles.scoped.css';

export function Upload() {
  const dispatch = useDispatch();

  const { setBreadcrumbs } = useContext(AppContext);
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('');
  const fileUrl =
    'https://storage.googleapis.com/fin-map-images-public-stage/templates/template%20status%20aktivasi%20pendaftaraan.csv';

  useEffect(() => {
    setBreadcrumbs(['Aktivasi Fitur Pendaftaran Subpangkalan', 'Ubah Aktivasi Dengan File']);
  }, []);

  const {
    dataUploadSubMerchantActivation,
    isLoadingUploadSubMerchantActivation,
    messageUploadSubMerchantActivation,
  } = useSelector((s) => s.subMerchantActivation);

  const handleDownloadDataFailRegist = () => {
    let a = document.createElement('a');
    a.href = messageUploadSubMerchantActivation?.link;
    a.click();
    setOpenModal(false);
  };

  const onBack = () => {
    let a = document.createElement('a');
    a.href = '/dc/registration-activation';
    a.click();
    setOpenModal(false);
  };

  useEffect(() => {
    if (
      afterSubmit &&
      messageUploadSubMerchantActivation !== '' &&
      messageUploadSubMerchantActivation !== undefined
    ) {
      if (messageUploadSubMerchantActivation === 'Template Update Harga Tidak Sesuai') {
        setOpenModal(true);
        setModalMode('somethingWrong');
      } else {
        setOpenModal(true);
        setModalMode('fail');
      }
    } else if (
      afterSubmit &&
      messageUploadSubMerchantActivation === '' &&
      !isLoadingUploadSubMerchantActivation &&
      dataUploadSubMerchantActivation?.failedData?.length === 0
    ) {
      setOpenModal(true);
      setModalMode('success');
    } else if (
      afterSubmit &&
      !isLoadingUploadSubMerchantActivation &&
      dataUploadSubMerchantActivation?.failedData?.length > 0
    ) {
      setOpenModal(true);
      setModalMode('successWithFail');
    }
  }, [dataUploadSubMerchantActivation, messageUploadSubMerchantActivation]);

  const infoUpload = [
    <span key={'info'}>Unduh file Excel <a download href={fileUrl}
      style={{ color: '#5E811E', cursor: 'pointer', fontWeight: 700 }}
    >di sini.</a></span>,
    'Atur harga eceran tertinggi.',
    'Unggah kembali file yang sudah diisi.'
  ];

  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        <FormUpload
          infoUpload={infoUpload}
          isLoading={isLoadingUploadSubMerchantActivation}
          onBack={'/registration-activation'}
          onSubmit={(values) =>
            dispatch(submitUploadSubMerchantActivation(values, setAfterSubmit(true)))
          }
          title="Pilih file dengan format .CSV untuk ubah harga dalam jumlah banyak"
        />
      </Card>
      <Modal
        centered
        onClose={() => setOpenModal(false)}
        opened={openModal}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles['modal-res-upload']} style={{ textAlign: 'center' }}>
          <span onClick={() => setOpenModal(false)}>
            <img className={styles['close-icon-modal']} src="assets/ic-close.svg" />
          </span>
          {modalMode === 'successWithFail' ? (
            <>
              <h5>Sebagian data berhasil diunggah</h5>
              <hr className={styles.separatirModal} />
              <Flex direction="column" gap="md" mt="md">
                <Card p="sm" radius="md" sx={{ padding: '10px' }} withBorder>
                  <Flex
                    align="center"
                    direction="row"
                    gap="sm"
                    pl={10}
                    sx={{ padding: '.3rem 1rem .3rem 1.25rem' }}
                  >
                    <IconSuccess type={'small'} />
                    <Text>
                      {dataUploadSubMerchantActivation?.successTotal} Pangkalan Berhasil Diaktivasi
                    </Text>
                  </Flex>
                </Card>
                <Accordion radius="md" variant="contained">
                  <Accordion.Item value="print">
                    <Accordion.Control icon={<IconFailed type={'small'} />} py=".2rem">
                      {dataUploadSubMerchantActivation?.failedTotal} Pangkalan Gagal Diaktivasi
                    </Accordion.Control>
                    <Accordion.Panel mx="sm" sx={{ borderTop: '1px solid #D9DEE4' }}>
                      {dataUploadSubMerchantActivation?.failedData?.map((item, index) => (
                        <Grid grow key={index} mt="sm">
                          <Grid.Col span={4}>
                            <Text fz={14} ta="left">
                              ID Pangkalan {item.registrationId}
                            </Text>
                          </Grid.Col>
                          <Grid.Col span={4}>
                            <Text fz={14} sx={{ color: '#CF212A' }} ta="right">
                              {item.reason}
                            </Text>
                          </Grid.Col>
                        </Grid>
                      ))}
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>
                <Button fullWidth onClick={() => setOpenModal(false)}>
                  Tutup
                </Button>
              </Flex>
            </>
          ) : (
            <h5>Unggah {modalMode === 'success' ? 'Berhasil' : 'Gagal'}</h5>
          )}
          {modalMode === 'fail' && (
            <p>Data gagal diupload. Segera perbaiki data yang gagal dan unggah kembali.</p>
          )}
          {modalMode === 'somethingWrong' && (
            <p>File yang diunggah tidak sesuai format, segera periksa data dan unggah kembali</p>
          )}
          {modalMode === 'success' && (
            <Button className={styles['action-btn-modal']} onClick={onBack}>
              Oke
            </Button>
          )}
          {modalMode === 'fail' && (
            <Button
              className={styles['action-btn-modal']}
              onClick={() => handleDownloadDataFailRegist()}
            >
              Tutup dan Unduh Data Gagal
            </Button>
          )}
          {modalMode === 'somethingWrong' && (
            <Button
              className={styles['action-btn-modal']}
              onClick={() => {
                setOpenModal(false), setAfterSubmit(false);
              }}
            >
              Ok
            </Button>
          )}
        </div>
      </Modal>
    </div>
  );
}

Upload.propTypes = {
  handleSubmit: PropTypes.func,
};
export default Upload;
